import type { WebModule } from '@nexus/core-web';

/**
 * Web parts of the modules in this build. Each module has its own file in `./modules`, written by
 * the module generator (skill `new-module`); which of them a company uses is decided per company
 * in the platform administration.
 */
const files = import.meta.glob<{ default: WebModule }>('./modules/*.ts', { eager: true });

export const WEB_MODULES: readonly WebModule[] = Object.values(files)
  .map((file) => file.default)
  .sort((a, b) => a.manifest.id.localeCompare(b.manifest.id));
